import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';
var badgeInContainerButtonStyle = createRuntimeFn({
  defaultClassName: 'styles__1mcxo5k3 styles__1mcxo5k2',
  variantClassNames: {
    color: {
      primary: 'styles_color_primary__1mcxo5k4',
      'secondary-color': 'styles_color_secondary-color__1mcxo5k5',
      'secondary-gray': 'styles_color_secondary-gray__1mcxo5k6',
      'tertiary-color': 'styles_color_tertiary-color__1mcxo5k7',
      'tertiary-gray': 'styles_color_tertiary-gray__1mcxo5k8',
      'negative-primary': 'styles_color_negative-primary__1mcxo5k9',
      'negative-secondary': 'styles_color_negative-secondary__1mcxo5ka'
    },
    disabled: {
      true: 'styles_disabled_true__1mcxo5kb'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var buttonTextContainerStyle = 'styles__1mcxo5k0';
var buttonTextStyle = 'styles__1mcxo5k1';
export { badgeInContainerButtonStyle, buttonTextContainerStyle, buttonTextStyle };
